// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-input-element:disabled,
.mat-date-range-input-inner[disabled],
.mat-form-field-appearance-outline.mat-form-field-disabled .mat-form-field-outline {
  color: #000;
}

::ng-deep .white .mat-form-field-wrapper {
  padding-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/date-range-picker/date-range-picker.component.scss"],"names":[],"mappings":"AAAA;;;EAGI,WAAA;AACJ;;AAGI;EACI,iBAAA;AAAR","sourcesContent":[".mat-input-element:disabled,\n.mat-date-range-input-inner[disabled],\n.mat-form-field-appearance-outline.mat-form-field-disabled .mat-form-field-outline {\n    color: #000;\n}\n\n::ng-deep {\n    .white .mat-form-field-wrapper {\n        padding-bottom: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
